<dx-tab-panel [animationEnabled]="true" itemTitleTemplate="translatedTemplate" style="height: 100%; display: flex;">

  <div *dxTemplate="let title of 'translatedTemplate'">
    <span>{{ title.caption | translate }}</span>
  </div>

  <!------------------------>
  <!--  Config tab        -->
  <!------------------------>

  <dxi-item caption="DASHBOARD.REPORTS.CONFIG_TAB" class="flexElement">
    <div class="flexFill" style="padding: 20px; overflow-y: auto;
                                 display: grid; grid-template-columns: repeat(12, 1fr); gap: 16px; align-content: start; height: 100%">

      <dx-form
        #reportForm
        [(formData)]="report"
        [colCount]="12"
        [disabled]="disabled"
        style="grid-column: 1 / span 10">

        <dxi-item [colSpan]="6" [editorOptions]="{ valueChangeEvent: 'keyup' }" dataField="name">
          <dxo-label [text]="'DASHBOARD.REPORTS.NAME' | translate"></dxo-label>
          <dxi-validation-rule type="required"></dxi-validation-rule>
          <dxi-validation-rule [max]="gmService.STR_DIM_MID"
                               [message]="appService.getMaxCharErrorMessage(gmService.STR_DIM_MID)"
                               type="stringLength"></dxi-validation-rule>
        </dxi-item>

        <dxi-item [colSpan]="6" [editorOptions]="{ valueChangeEvent: 'keyup' }" dataField="email">
          <dxo-label [text]="'DASHBOARD.REPORTS.EMAIL' | translate"></dxo-label>
          <dxi-validation-rule type="required"></dxi-validation-rule>
          <dxi-validation-rule [pattern]="appService.EMAIL_PATTERN" type="pattern"></dxi-validation-rule>
          <dxi-validation-rule [max]="gmService.STR_DIM_MAX"
                               [message]="appService.getMaxCharErrorMessage(gmService.STR_DIM_MAX)"
                               type="stringLength"></dxi-validation-rule>
        </dxi-item>

      </dx-form>

      <div style="grid-column: 11 / -1; justify-self: end; align-self: end; display: flex; flex-direction: column; align-items: flex-end; gap: 4px;">
        <span [style.opacity]="disabled ? '0.5' : '1'" style="font-size: 13px;">{{ 'DASHBOARD.REPORTS.ENABLED' | translate }}</span>
        <dx-switch [(value)]="report.enabled" [disabled]="disabled"></dx-switch>
      </div>

      <div style="grid-column: 1 / -1">
        <app-cron-input
          [(value)]="report.unixCronExpression"
          [disabled]="disabled">
        </app-cron-input>
      </div>

      <hr style="grid-column: 1 / -1; border: none; border-top: 1px solid var(--dx-color-border, #ddd); margin: 0;">

      <dx-form
        #bucketForm
        [(formData)]="report"
        [colCount]="12"
        [disabled]="disabled"
        style="grid-column: 1 / -1">

        <dxi-item
          [colSpan]="6"
          [editorOptions]="{ min: 1, showSpinButtons: true }"
          dataField="bucketValue"
          editorType="dxNumberBox">
          <dxo-label [text]="'DASHBOARD.REPORTS.BUCKET_VALUE' | translate"></dxo-label>
          <dxi-validation-rule type="required"></dxi-validation-rule>
        </dxi-item>

        <dxi-item
          [colSpan]="6"
          [editorOptions]="{ dataSource: bucketUnitValues, displayExpr: getBucketUnitLabel }"
          dataField="bucketUnits"
          cssClass="bucket-units-box"
          editorType="dxSelectBox">
          <dxo-label [visible]="false"></dxo-label>
          <dxi-validation-rule type="required"></dxi-validation-rule>
        </dxi-item>


      </dx-form>

      <app-report-metrics-table
        [metrics]="report.metrics ?? []"
        [disabled]="disabled"
        style="grid-column: 1 / -1; overflow: hidden">
      </app-report-metrics-table>

    </div>
  </dxi-item>

  <!------------------------>
  <!--  Metrics tab       -->
  <!------------------------>

  <dxi-item [disabled]="disabled" caption="DASHBOARD.REPORTS.METRICS_TAB" class="flexElement">
    <div class="metricsFormBody">
      <div class="flexRow">
        <app-partition-selector
          [(selectedPartition)]="dashboardService.selectedPartitionIds[0]"
          class="flexFill">
        </app-partition-selector>
      </div>
      <div class="absoluteWrapper">
        <div class="sideBySideLists absoluteFill">
          <app-device-selector
            #deviceSelectorComponent
            [(selectedDeviceId)]="dashboardService.selectedDeviceIds[0]"
            [selectedPartitionId]="dashboardService.selectedPartitionIds[0]">
          </app-device-selector>
          <app-metric-selector
            (newSelectedMetric)="convertSelectedMetric($event)"
            [deviceList]="deviceSelectorComponent.deviceList"
            [forbidSVM]="false"
            [forbiddenDataTypes]="[]"
            [inputDisplayMode]="'table'"
            [selectedDeviceId]="dashboardService.selectedDeviceIds[0]"
            [selectedPartitionId]="dashboardService.selectedPartitionIds[0]">
          </app-metric-selector>
        </div>
      </div>
    </div>
  </dxi-item>

</dx-tab-panel>
